/*
 * @Author: zyq
 * @Date: 2022-10-19 09:57:01
 * @LastEditors: zyq
 * @LastEditTime: 2022-10-25 21:00:31
 * @description:
 */
import { Message } from 'element-ui'
import Vue from 'vue'
import VueRouter from 'vue-router'
import { initConfig } from '@/utils/wxUtil'

Vue.use(VueRouter)

const routes = [
  {
    path: '/index',
    name: 'index',
    component: () => import('@/views/index/index.vue')
  },
  {
    path: '/',
    name: 'home',
    // meta: { keepAlive: true },
    component: () => import('@/views/home/home.vue')
  },
  {
    path: '/exam',
    name: 'exam',
    component: () => import('@/views/exam/exam.vue')
  },
  {
    path: '/rank',
    name: 'rank',
    component: () => import('@/views/rank/rank.vue')
  },
  {
    path: '/score',
    name: 'score',
    component: () => import('@/views/score/score.vue')
  },
  {
    path: '/team',
    name: 'team',
    component: () => import('@/views/teamRank/team.vue')
  }
]

const router = new VueRouter({
  // refactor
  // mode: 'hash',
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  // refactor
  // next()
  // return;

  // 配置分享
  initConfig({
    url: location.href
  }).then(i => i)
  if (to.name !== 'home') {
    if (!localStorage.getItem('userId')) {
      Message.error({
        showClose: true,
        message: '请到微信客户端进行登陆',
        type: 'error',
        duration: 3000
      })
      return
    }
  }
  if (to.name !== 'home' && from.name !== 'home') {
    if (to.name === 'exam' && from.name === 'team') {
      next()
    } else if (to.name === 'rank' && (from.name === 'score' || from.name === 'index')) {
      next()
    } else if (to.name === 'score' && (from.name === 'exam' || from.name === 'index')) {
      next()
    } else if (to.name === 'exam' && (from.name === 'score' || from.name === 'index')) {
      next()
    } else {
      next({
        name: 'home'
      })
      return
    }
  }
  next()
})

// 解决使用router.push路由重复报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router
